import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from "@mui/material";
import { useTranslation } from "shared/hooks/useTranslation";

interface SplitTypeSelectProps {
    value: string;
    onChange: (value: string) => void;
    disabled?: boolean;
}

export default function SplitTypeSelect({ value, onChange, disabled }: SplitTypeSelectProps) {
    const { t } = useTranslation();
    return (
        <FormControl fullWidth size="small">
            <InputLabel >{t("forms.splitType")}</InputLabel>
            <Select
                value={value}
                label={t("forms.splitType")}
                onChange={(e) => onChange(e.target.value)}
                disabled={disabled}
                MenuProps={{ disableScrollLock: true }}
            >
                <MenuItem value="equal">{t("forms.equalSplit")}</MenuItem>
                <MenuItem value="custom">{t("forms.customSplit")}</MenuItem>
            </Select>
            <FormHelperText>{t("forms.splitTypeHint")}</FormHelperText>
        </FormControl>
    );
}
